import React, { useMemo } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import WarningIcon from "@mui/icons-material/Warning";
import AlarmOffOutlinedIcon from "@mui/icons-material/AlarmOffOutlined";
import ErrorIcon from "@mui/icons-material/Error";
import PauseIcon from "@mui/icons-material/Pause";
import { useStyles } from "./MachineCenterTrafficLights.styles";
import { useTranslation } from "react-i18next";
import { IMachineCenterTrafficLightsIconsProps } from "./MachineCenterTrafficLightsInterfaces";
import { IconsTrafficLightStatusCodes } from "constants/constants";

export const MachineCenterTrafficLightsIcons = ({
    status,
    isBottleneck,
    noPercentageData,
    bigSize,
}: IMachineCenterTrafficLightsIconsProps) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const OfflineIcon = useMemo(
        () => (
            <div className={classes.offlineIconWrapper}>
                <WarningIcon className={bigSize ? classes.bigIcon : ""} />
                <div className={classes.offlineIconLabel}>{t("locations.mill_dashboards.downtime_item.offline")}</div>
            </div>
        ),
        [classes.offlineIconLabel, classes.offlineIconWrapper, t, bigSize, classes.bigIcon],
    );
    return (
        <>
            {isBottleneck ? (
                <img
                    src={"/images/bottle.png"}
                    alt="Bottleneck"
                    className={`${bigSize ? classes.bigImage : ""} ${
                        status === IconsTrafficLightStatusCodes.BELOW_TRIGGER ? classes.bottleImage : ""
                    }`}
                />
            ) : (
                <>
                    {status === IconsTrafficLightStatusCodes.OFFLINE && OfflineIcon}
                    {status === IconsTrafficLightStatusCodes.UP && (
                        <CheckIcon className={bigSize ? classes.bigIcon : ""} />
                    )}
                    {status === IconsTrafficLightStatusCodes.DOWN && (
                        <CancelIcon className={bigSize ? classes.bigIcon : ""} />
                    )}
                    {status === IconsTrafficLightStatusCodes.END_OF_SHIFT && noPercentageData && (
                        <ErrorIcon className={bigSize ? classes.bigIcon : ""} />
                    )}
                    {status === IconsTrafficLightStatusCodes.END_OF_SHIFT && !noPercentageData && (
                        <AlarmOffOutlinedIcon className={bigSize ? classes.bigIcon : ""} />
                    )}
                    {status === IconsTrafficLightStatusCodes.BELOW_TRIGGER && (
                        <PauseIcon className={bigSize ? classes.bigIcon : ""} />
                    )}
                </>
            )}
        </>
    );
};
